import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { usePageMeta } from "@/hooks/usePageMeta";

const content = {
  mentions: {
    title: "Mentions légales",
    testid: "legal-mentions",
    blocks: [
      {
        heading: "Éditeur du site",
        text: "construiremaison.net — Le Guide pour construire sa maison. Site d'information destiné aux particuliers préparant un projet de construction de maison individuelle en France. Contact : contact@construiremaison.net.",
      },
      {
        heading: "Hébergement",
        text: "Les informations relatives à l'hébergeur du site sont disponibles sur demande à l'adresse de contact ci-dessus.",
      },
      {
        heading: "Propriété intellectuelle",
        text: "L'ensemble des contenus du site (textes, vidéos, simulateurs, éléments graphiques) est protégé. Toute reproduction ou réutilisation sans autorisation écrite préalable est interdite.",
      },
      {
        heading: "Responsabilité",
        text: "Les informations et simulations proposées sont fournies à titre indicatif et pédagogique. Elles ne constituent ni un conseil juridique, ni un conseil financier, ni un engagement contractuel. Pour toute décision engageante (achat de terrain, prêt, contrat de construction), consultez un professionnel : notaire, banque, architecte ou constructeur.",
      },
    ],
  },
  privacy: {
    title: "Politique de confidentialité",
    testid: "legal-privacy",
    blocks: [
      {
        heading: "Données collectées",
        text: "Nous collectons uniquement les données que vous nous transmettez volontairement : votre adresse email lors de l'inscription à la newsletter, et le contenu de vos échanges avec l'assistant virtuel, afin d'améliorer la qualité des réponses.",
      },
      {
        heading: "Utilisation",
        text: "Votre adresse email sert exclusivement à vous envoyer nos nouveaux guides et vidéos. Elle n'est ni vendue, ni partagée avec des tiers. Les conversations avec l'assistant sont utilisées uniquement pour améliorer le service.",
      },
      {
        heading: "Vos droits",
        text: "Conformément au RGPD, vous disposez d'un droit d'accès, de rectification et de suppression de vos données. Écrivez à contact@construiremaison.net pour l'exercer. La désinscription de la newsletter est possible à tout moment.",
      },
      {
        heading: "Cookies",
        text: "Le site peut utiliser des cookies de mesure d'audience. Vous pouvez les accepter ou les refuser via la bannière prévue à cet effet, sans impact sur l'accès aux contenus.",
      },
    ],
  },
};

export default function LegalPage({ kind }) {
  const page = content[kind];

  usePageMeta(
    `${page.title} | ConstruireMaison.net`,
    `${page.title} du site ConstruireMaison.net, le guide gratuit pour construire sa maison.`
  );

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [kind]);

  return (
    <div data-testid={page.testid}>
      <header className="border-b border-border bg-bone/90 backdrop-blur-md sticky top-0 z-40">
        <div className="max-w-4xl mx-auto px-6 h-16 flex items-center justify-between">
          <Link to="/" className="font-sub font-extrabold tracking-tight text-xl" data-testid="legal-logo">
            construire<span className="text-terra">maison</span>.net
          </Link>
          <Link
            to="/"
            data-testid="legal-back-link"
            className="inline-flex items-center gap-2 font-sub text-sm text-ink/70 hover:text-terra transition-colors duration-200"
          >
            <ArrowLeft className="w-4 h-4" />
            Retour à l'accueil
          </Link>
        </div>
      </header>
      <div className="max-w-4xl mx-auto px-6 py-16 lg:py-24">
        <h1 className="font-display text-4xl sm:text-5xl leading-[1.1] tracking-tight mb-12" data-testid="legal-title">
          {page.title}
        </h1>
        {page.blocks.map((b) => (
          <section key={b.heading} className="mb-10">
            <h2 className="font-sub font-bold text-xl mb-3">{b.heading}</h2>
            <p className="text-base leading-relaxed text-ink/75">{b.text}</p>
          </section>
        ))}
      </div>
    </div>
  );
}
